import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { getAuthToken } from "@/lib/api";
import { apiOrigin, env } from "@/lib/env";

type EchoInstance = InstanceType<typeof Echo>;

declare global {
  interface Window {
    Pusher: typeof Pusher;
    Echo?: EchoInstance;
  }
}

window.Pusher = Pusher;

const scheme = env("REVERB_SCHEME", "http");
const host = env("REVERB_HOST", "localhost");
const port = Number(env("REVERB_PORT", "8080"));
const key = env("REVERB_APP_KEY", "");

let echoInstance: EchoInstance | null = null;

export function getEcho(): EchoInstance | null {
  const token = getAuthToken();
  if (!token || !key) {
    return null;
  }

  if (echoInstance) {
    return echoInstance;
  }

  echoInstance = new Echo({
    broadcaster: "reverb",
    key,
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS: scheme === "https",
    enabledTransports: ["ws", "wss"],
    authEndpoint: `${apiOrigin()}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    },
  });

  return echoInstance;
}

export function disconnectEcho(): void {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
}
